"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = _interopRequireDefault(require("../Box/Box"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _excluded = ["label", "id", "helperText", "children", "disabled", "value", "onChange", "onBlur", "error", "icon", "height", "noRotate"];

var SelectField = _styledComponents["default"].select.withConfig({
  displayName: "Select__SelectField",
  componentId: "sc-1eaqdh0-0"
})(["", " ", " ", " position:relative;appearance:none;padding:20px 42px 6px 16px;border-radius:4px 4px 0 0;font-family:", ";font-size:", "px;font-weight:400;color:", ";line-height:1.75;letter-spacing:0.009375em;border:none;border-bottom:1px solid ", ";background-color:", ";outline:0;text-overflow:ellipsis;&:hover{background-color:", ";border-bottom:1px solid ", ";}&:focus{background-color:", ";border-bottom:2px solid ", ";transition:0.15s;& + label{color:", ";}}&:disabled{opacity:0.6;cursor:not-allowed;&:hover{background-color:", ";border-bottom:1px solid ", ";}& + label{opacity:0.6;}}& + label{color:", ";font-family:", ";left:16px;right:auto;top:18px;pointer-events:none;position:absolute;line-height:1.15rem;transition:0.15s;transform:translateY(-50%) translateX(-15%) scale(0.75);}"], _styledSystem.width, _styledSystem.space, _styledSystem.height, function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.sansSerif;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes[4];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.dark[1];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.dark[3];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.dark[7];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.dark[6];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.dark[1];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.dark[5];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.primary[0];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary[1];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.dark[7];
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.dark[3];
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.dark[2];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fonts.sansSerif;
});

var Wrapper = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Select__Wrapper",
  componentId: "sc-1eaqdh0-1"
})(["position:relative;&:before{content:\"", "\";font-family:\"EngagingTechIcons\";font-size:16px;line-height:1;width:16px;height:16px;position:absolute;top:20px;right:16px;transition:180ms;opacity:", ";z-index:1;pointer-events:none;}&:focus-within{&:before{transform:", ";}}"], function (_ref15) {
  var icon = _ref15.icon;
  return icon;
}, function (_ref16) {
  var isDisabled = _ref16.isDisabled;
  return isDisabled ? 0.6 : 1;
}, function (_ref17) {
  var noRotate = _ref17.noRotate;
  return noRotate ? "none" : "rotate(180deg)";
});

var Select = function Select(_ref18) {
  var label = _ref18.label,
      id = _ref18.id,
      helperText = _ref18.helperText,
      children = _ref18.children,
      disabled = _ref18.disabled,
      value = _ref18.value,
      onChange = _ref18.onChange,
      onBlur = _ref18.onBlur,
      error = _ref18.error,
      icon = _ref18.icon,
      height = _ref18.height,
      noRotate = _ref18.noRotate,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref18, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({}, props, {
    icon: icon,
    isDisabled: disabled,
    noRotate: noRotate
  }), /*#__PURE__*/_react["default"].createElement(SelectField, {
    width: 1 / 1,
    id: id,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    disabled: disabled,
    height: height,
    error: error
  }, children), label && /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, label), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    width: 1 / 1
  }, (error || helperText) && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: error ? "error.0" : "dark.2",
    fontSize: 2,
    pl: 3
  }, error || helperText)));
};
/* eslint-disable react/forbid-prop-types */


Select.propTypes = {
  label: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  helperText: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  value: _propTypes["default"].any,
  icon: _propTypes["default"].string,
  noRotate: _propTypes["default"].bool
};
/* eslint-enable react/forbid-prop-types */

Select.defaultProps = {
  label: "",
  helperText: "",
  disabled: false,
  onChange: function onChange() {
    return null;
  },
  onBlur: function onBlur() {
    return null;
  },
  value: null,
  icon: "arrow_drop_down",
  noRotate: false
};
var _default = Select;
exports["default"] = _default;